import axios from "axios";
import moment from "moment";
import Imprimir from "./../base/Imprimir";
import { mapState, mapActions } from "vuex";
import swal from "sweetalert";
// import Chart from '@/components/base/Chart.vue'
import ModalImprimir from "@/components/base/ModalImprimir.vue";
import bus from "@/EventBus";
import Headers from "../headers/headerVentas";
import Banner from "@/components/base/Banner.vue"

export default {
  data: (vm) => ({
    date: new Date().toISOString().substr(0, 10),
    dateFiltroDist: new Date().toISOString().substr(0, 10),
    dateFiltroPedidos: new Date().toISOString().substr(0, 10),
    dateFiltroAlmacen: new Date().toISOString().substr(0, 10),
    dateFiltroReparto: new Date().toISOString().substr(0, 10),
    dateFormatted: moment(new Date()).format("L"),
    menuFiltroDistribucion: false,
    menuFiltroPedidos: false,
    menuFiltroAlmacen: false,
    menuFiltroReparto: false,
    menu1: false,
    entrega: false,
    negocio: 2,
    dialog: false,
    banner:false,

    search1: "",
    search2: "",
    search3: "",
    search4: "",

    headers: Headers.headers,
    headersPedido: Headers.headersPedido,
    cabeceraDetalles: Headers.cabeceraDetalles,
    cabeceraArticulos: Headers.cabeceraArticulos,
    modoChart: Headers.modoChart,
    negocios: Headers.negocios,
    comprobantes: Headers.comprobantes,
    unidades: Headers.unidades,

    ventasAlmacen: [],
    ventasAlmacenDate: [],

    ventasReparto: [],
    ventasRepartoDate: [],

    pedidosReparto: [],
    pedidosRepartoDate: [],

    pedidosAlmacen: [],
    pedidosAlmacenDate: [],

    _id: "",
    persona: "",
    personas: [],

    tipo_comprobante: "",
    unidad: "",

    serie_comprobante: "",
    num_comprobante: "",
    pagado: 0,
    impuesto: 0.22,
    codigo: "",

    detalles: [],
    verNuevo: 0,
    errorArticulo: null,
    descripcion: "",
    total: 0,
    totalParcial: 0,
    totalImpuesto: 0,
    // articulosFiltrados: [],
    texto: "",
    imprimir: [],
    verDetalle: 0,
    valida: 0,
    validaMensaje: [],
    adModal: 0,
    adAccion: 0,
    comprobanteModal: 0,
    adNombre: "",
    estado: 3,
    adId: "",
    fecha: null,
    imprimirNegocio: false,
    send: null,
  }),
  components: {
    Imprimir,
    ModalImprimir,
    Banner
  },
  created() {
    moment.locale("es");
    this.listar();
    this.selectPersona();
    this.getClientes(this.token);
    this.getVentas(this.token);
  },
  mounted() {
    bus.$on("cargarLista", () => {
      this.listar();
    });
    
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    date(val) {
      let date = new Date();
      date = moment(date).format("Y-MM-DD");
      if (val < date) {
        this.dateFormatted = moment(new Date()).format("L");
        swal({
          title: "Alerta!",
          text: `La fechan no puede ser menor a ${this.dateFormatted}`,
          icon: "warning",
        });
      }
    },
    dateFiltroDist: function(date_select) {
      this.functionPedidosReparto(date_select);
    },
    dateFiltroPedidos: function(date_select) {
      this.functionPedidosAlmacen(date_select);
    },
    dateFiltroAlmacen: function(date_select) {
      this.functionVentasAlmacen(date_select);
    },
    dateFiltroReparto: function(date_select) {
      this.functionVentasReparto(date_select);
    },
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario"]),
    ...mapState("clienteNamespace", ["clientes"]),
    ...mapState("ventasNamespace", ["ventas", "venta"]),
    ...mapState("articulosNamespace", ["articulos"]),
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    calcularTotal: function() {
      let resultado = 0.0;
      for (var i = 0; i < this.detalles.length; i++) {
        resultado =
          resultado + this.detalles[i].cantidad * this.detalles[i].precio;
      }
      return resultado;
    },
    verooeditar: function() {
      let v = "";
      switch (this.verNuevo) {
        case 1:
          v = "Nuevo pedido";
          break;
        case 2:
          v = "Edición del pedido";
          break;
        case 3:
          v = "Detalle del pedido";
          break;
        default:
          v = "Nuevo pedido";
      }
      return v;
    },
    esAdministrador() {
      return this.usuario.rol == "Administrador";
    },
  },
  methods: {
    ...mapActions("deudasNamespace", ["getDeudas"]),
    ...mapActions("articulosNamespace", ["getArticulos"]),
    ...mapActions("clienteNamespace", ["getClientes"]),
    ...mapActions("ventasNamespace", [
      "getVentas",
      "getVenta",
      "saveVenta",
      "updateVenta",
      "sendVenta",
      "nosendVenta",
      "deleteVenta",
      "activateVenta",
      "deactivateVenta",
    ]),
    // nextFocus(e) {
    //   // e.target.nextElementSibling.focus()
    //   this.$nextTick(() => e.target.nextElementSibling.focus())
    //   console.log('Enter')
    // },
    mostrarNuevo() {
      // this.banner = true;
      this.send = "post";
      this.verNuevo = 1;
      this.$nextTick(() => this.$refs.cliente.focus())
    },
    ocultarNuevo() {
      this.verNuevo = 0;
    },
    selectPersona() {
      let me = this;
      let clientesArr = this.clientes;
      clientesArr.map(function(x) {
        me.personas.push({ text: x.nombre, value: x._id });
      });
    },
    changeDate($event) {
      this.dateFormatted = moment($event).format("L");
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    preImpresion(item) {
      this.$refs.imprimir.dialog = true;
      debugger
      this.limpiar();
      this.imprimir = [];
      this.imprimir.push({
        tipo_comprobante: item.tipo_comprobante,
        serie_comprobante: item.serie_comprobante,
        num_comprobante: item.num_comprobante,
        fecha: item.entregaAt,
        persona: item.persona,
        detalles: item.detalles,
        total: item.total,
      });
      this.comprobanteModal = 1;
      this.$refs.imprimir.llamarCliente();
    },
    imprimirVarios(p) {
      this.limpiar();
      if (p == 2) {
        this.imprimirNegocio = true;
      }
      this.$refs.modal_imprimir.filtroImprimir = true;
      //this.filtroImprimir = 1;
    },
    agregarDetalle(data) {
      this.errorArticulo = null;
      // this.texto = "";
      if (!this.encuentra(data._id)) {
        this.detalles.push({
          _id: data._id,
          articulo: data.nombre,
          cantidad: 1,
          unidad: data.unidad,
          precio: data.precio_venta,
          descuento: 0,
          descripcion: data.descripcion,
          categoria: data.categoria.nombre,
        });
        this.texto = "";
        this.$nextTick(() => this.$refs.search.focus());
        return;
      }

      this.errorArticulo = "El artículo ya ha sido agregado.";
    },
    encuentra(id) {
      let sw = this.detalles.find(detalle => detalle._id == id);
      return sw !== undefined;
    },
    eliminarDetalle(arr, item) {
      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },
    listarArticulos() {
      this.getArticulos({
        texto: this.texto,
        token: this.token,
      });
    },
    async listarDetalles(id) {
      await this.getVenta({
        id: id,
        token: this.token,
      });
      this.detalles = await this.venta.detalles;
    },
    verIngreso(item) {
      //debuger;

      this.limpiar();
      this.tipo_comprobante = item.tipo_comprobante;
      this.serie_comprobante = item.serie_comprobante;
      this.num_comprobante = item.num_comprobante;
      this.persona = item.persona._id;
      this.negocio = item.negocio;
      this.entrega = item.entrega;
      this.pagado = item.pagado;
      this.dateFormatted = item.entregaAt;
      this.listarDetalles(item._id);
      this.verNuevo = 3;
      this.verDetalle = 1;
    },
    limpiar() {
      this._id = "";
      this.tipo_comprobante = "";
      this.serie_comprobante = "";
      this.num_comprobante = "";
      this.persona = "";
      this.negocio = 2;
      this.codigo = "";
      this.texto = "";
      this.entrega = false;
      this.pagado = 0;
      this.total = 0;
      this.totalParcial = 0;
      this.totalImpuesto = 0;
      this.detalles = [];
      this.imprimir = [];
      this.imprimirNegocio = false;
      this.$refs.modal_imprimir.filtroImprimir = false;
      this.comprobanteModal = 0;
      this.verNuevo = 0;
      this.valida = 0;
      this.validaMensaje = [];
      this.verDetalle = 0;
    },
    validar() {
      this.valida = 0;
      this.validaMensaje = [];
      let me = this;
      this.detalles.forEach((i) => {
        if (!i.unidad) {
          this.validaMensaje.push(
            `Debe seleccionar la unidad para el articulo ${i.articulo}`
          );
        }
      });
      if (!this.persona) {
        this.validaMensaje.push("Seleccione un cliente.");
      }
      if (this.detalles.length <= 0) {
        this.validaMensaje.push("Ingrese al menos un artículo al detalle");
      }
      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.num_comprobante;
      this.adId = item._id;
      if (accion == 1) {
        this.adAccion = 1; //"Activar Venta"
      } else if (accion == 2) {
        this.adAccion = 2; //"Desactivar venta Venta"
      } else if (accion == 3) {
        this.adAccion = 3; //"Eliminar pedido"
      } else {
        this.adModal = 0;
      }
    },
    entregaFn(accion, item) {
      this.adModal = 1;
      this.adNombre = item.num_comprobante;
      this.adId = item._id;
      if (accion == 1) {
        this.adAccion = 4;
        this.entrega = true; //"Pedido entregado"
      } else if (accion == 2) {
        this.adAccion = 5;
        this.entrega = false; //"Pedido no entregado"
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    editItem(item) {
      this.limpiar();
      this.send = "put";
      this._id = item._id;
      this.persona = item.persona._id;
      this.tipo_comprobante = item.tipo_comprobante;
      this.serie_comprobante = item.serie_comprobante;
      this.num_comprobante = item.num_comprobante;
      this.total = item.total;
      this.detalles = item.detalles;
      this.negocio = item.negocio;
      this.entrega = item.entrega;
      this.pagado = item.pagado;
      this.dateFormatted = item.entregaAt;
      this.verNuevo = 2;
      this.editedIndex = 1;
    },
    close() {
      this.dialog = false;
      this.imprimir = [];
      this.verNuevo = 0;
      this.$refs.modal_imprimir.filtroImprimir = false;
      //this.filtroImprimir = 0;
    },
    updateUnidad(unidad, item) {
      this.detalles.forEach((element) => {
        if (element.articulo == item.articulo) {
          element.unidad = unidad;
        }
      });
    },
    async listar() {
      let me = this;
      me.ventasReparto = [];
      me.pedidosReparto = [];
      me.pedidosAlmacen = [];
      me.ventasAlmacen = [];
      let response = await this.ventas;

      response.forEach(async (element) => {
        element.entregaAt = moment(element.entregaAt).format("L");
        if (element.negocio === 1) {
          if (element.entrega != false) {
            me.ventasAlmacen.push(element);
          } else {
            me.pedidosAlmacen.push(element);
          }
        } else if (element.entrega != false) {
          me.ventasReparto.push(element);
        } else {
          me.pedidosReparto.push(element);
        }
      });
      this.functionPedidosReparto(this.dateFiltroDist);
      this.functionPedidosAlmacen(this.dateFiltroPedidos);
      this.functionVentasAlmacen(this.dateFiltroAlmacen);
      this.functionVentasReparto(this.dateFiltroReparto);
    },
    guardar() {
      let me = this;
      if (this.validar()) {
        return;
      }
      if (this.entrega) {
        this.entrega = true;
        this.estado = 1;
      } else {
        this.estado = 3;
      }
      if (this.send == "put") {
        //Código para editar
        this.updateVenta({
          token: this.token,
          id: this._id,
          persona: this.persona,
          usuario: this.usuario._id,
          tipo_comprobante: this.tipo_comprobante,
          serie_comprobante: this.serie_comprobante,
          num_comprobante: this.num_comprobante,
          pagado: this.pagado,
          total: this.total,
          negocio: this.negocio,
          entregaAt: moment(this.dateFormatted, "L").format(),
          entrega: this.entrega,
          estado: this.estado,
          detalles: this.detalles,
        });
        this.getDeudas(this.token);
        this.listar();
        this.limpiar();
        me.close();
      } else {
        //Código para guardar
        let entrega = this.entrega == null ? false : this.entrega;
        this.saveVenta({
          token: this.token,
          persona: this.persona,
          usuario: this.usuario._id,
          tipo_comprobante: this.tipo_comprobante,
          serie_comprobante: this.serie_comprobante,
          num_comprobante: this.num_comprobante,
          pagado: this.pagado,
          total: this.total,
          negocio: this.negocio,
          entrega: entrega,
          entregaAt: moment(this.dateFormatted, "L").format(),
          estado: this.estado,
          detalles: this.detalles,
        });
        this.getDeudas(this.token);
        this.listar();
        me.close();
      }
    },
    entregado() {
      this.sendVenta({
        token: this.token,
        id: this.adId,
      });
      this.adModal = 0;
      this.adAccion = 0;
      this.adNombre = "";
      this.adId = "";
    },
    noEntregado() {
      this.nosendVenta({
        token: this.token,
        id: this.adId,
      });

      this.adModal = 0;
      this.adAccion = 0;
      this.adNombre = "";
      this.adId = "";
    },
    activar() {
      this.activateVenta({ token: this.token, id: this.adId });
      this.adModal = 0;
      this.adAccion = 0;
      this.adNombre = "";
      this.adId = "";
    },
    desactivar() {
      this.deactivateVenta({ token: this.token, id: this.adId });
      this.adModal = 0;
      this.adAccion = 0;
      this.adNombre = "";
      this.adId = "";
    },
    eliminarPedido() {
      this.deleteVenta({
        token: this.token,
        id: this.adId,
      });
      this.adModal = 0;
      this.adAccion = 0;
      this.adNombre = "";
      this.adId = "";
    },
    functionPedidosReparto(date) {
      let new_date = moment(date).format();
      let me = this;
      this.pedidosRepartoDate = [];
      this.pedidosReparto.forEach((element) => {
        let eachDate = moment(element.entregaAt, "L").format();
        if (new_date == eachDate) {
          me.pedidosRepartoDate.push(element);
        }
      });
    },
    functionPedidosAlmacen(date) {
      let new_date = moment(date).format();
      let me = this;
      this.pedidosAlmacenDate = [];
      this.pedidosAlmacen.forEach((element) => {
        let eachDate = moment(element.entregaAt, "L").format();
        if (new_date == eachDate) {
          me.pedidosAlmacenDate.push(element);
        }
      });
    },
    functionVentasAlmacen(date) {
      let new_date = moment(date).format();
      let me = this;
      this.ventasAlmacenDate = [];
      this.ventasAlmacen.forEach((element) => {
        let eachDate = moment(element.entregaAt, "L").format();
        if (new_date == eachDate) {
          me.ventasAlmacenDate.push(element);
        }
      });
    },
    functionVentasReparto(date) {
      let new_date = moment(date).format();
      let me = this;
      this.ventasRepartoDate = [];

      this.ventasReparto.forEach((element) => {
        let eachDate = moment(element.entregaAt, "L").format();
        if (new_date == eachDate) {
          me.ventasRepartoDate.push(element);
        }
      });
    },
  },
};
